import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

import vizLogo from "../../assets/Images/Vizlink_logo.png";

export default function TermsAndConditions() {
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
      }}
    >
      <h1 style={{ textAlign: "center" }}>Terms and Conditions</h1>

      <section>
        <p>
          Welcome to <a href="https://vizpro.com.pk">vizpro.com.pk</a> also
          hereby known as “we”, “us” “they” “our” or “Vizpro”. We are an online
          platform that allows merchants all over Pakistan (“User/Users”) to
          make digital payments, avail retailer financing, achieve operational
          automation, and other related services to merchants across Pakistan.
          (“Services”) who access and register our site along with its related
          sub-domains, sites, mobile app, services and tools including but not
          limited to Vizlink (“Platform(s)”)
        </p>
        <p>
          Please read the following terms and conditions (“Terms”) which govern
          your access and use of Vizpro. These also contain important
          information about your rights and obligations, as well as limitations
          and exclusions that apply to your use of Vizpro.
        </p>
        <p>
          By using the Platform, you hereby accept these Terms (including the
          linked information herein) and represent that you agree to comply with
          these Terms. These Terms is deemed effective upon your use of the
          Platform which signifies your acceptance of these Terms. If you do not
          agree to be bound by these Terms please do not access, register with
          or use this Platform.
        </p>
        <p>
          Vizpro reserves the unfettered right to change, modify, add, or remove
          portions of these Terms at any time without any prior notification.
          Changes will be effective when posted on the Platform with no other
          notice provided. Please keep yourself updated regarding these Terms.
          Your continued use of the Platform following the posting of changes to
          these Terms of use constitutes your acceptance of those changes.
        </p>
      </section>

      <section>
        <h2 style={{ textDecoration: "underline" }}>A. Conditions of Use</h2>

        <h3>1. Registration</h3>
        <p>
          You are the sole authorized User of any account (“Account”) you create
          using the Platform. Your action of successful registration constitutes
          your acceptance of these Terms and the Privacy Policy. Registration is
          free of charge. Mere registration creates no entitlement for provision
          of the Services through the Platform. The data required for
          registration provided by the User must be complete and accurate. The
          User is responsible for updating its/his/her own data that can be
          amended at any time from the respective interface of the Platform.
          Vizpro has no responsibility over the use of the User Account and
          expressly disclaims any liability therefrom.
        </p>
        <p>
          Should a User suspect that any unauthorized party might be using
          its/his/her Account that User is under an obligation to notify Vizpro
          immediately by emailing us at info@vizpro.com.pk. By providing the
          personal details to Vizpro at the time of registration and pursuant to
          the use of the Platform, the User hereby affirmatively consents to our
          use of its/his/her personal details for contacting it/him/her directly
          in order to perform the Services, including, but not limited to,
          occasionally sending notifications, text messages with promotional
          offers, service updates and reaching out to the User to survey
          regarding the quality of the Platform. Notwithstanding anything
          contained herein, Vizpro at its sole discretion reserves the right to
          restrict, suspend, or terminate the User’s Account if it is believed
          that the User is or may be in breach of these Terms or law or is
          misusing the Services.
        </p>

        <h3>2. User's Accounts</h3>
        <p>
          Users must be registered on the Platform to access or use our
          Services. Each shop is considered one Account. While there can be
          multiple Users associated with a single shop or distributor, the
          registration of multiple Accounts for the same shop of distributor is
          not permitted except with Vizpro’s prior approval. Further, Vizpro may
          reject User’s application for registration for any other reason.
        </p>
        <p>
          Upon registration on the Platform, Vizpro shall assign an account and
          issue a User ID and password (the latter shall be chosen by a User
          during registration) to each User (“User ID”).
        </p>
        <p>
          Each User shall be solely responsible for maintaining the
          confidentiality and security of their User ID and for all activities
          that occur under their Account. No User must share, assign, or permit
          the use of its/his/her User ID by another person outside of the User’s
          own business. Users agree to notify Vizpro immediately if they become
          aware of any unauthorized use of their password or account or any
          other breach of security of their Account.
        </p>
        <p>
          All Users agree that all the activities that occur under their Account
          (including without limitation, adding any information, clicking to
          accept any additional agreements or rules, subscribing to any
          Services, sending emails using the email account or sending short
          messaging services) will be deemed to have been authorized by the
          User.
        </p>
        <p>
          All Users acknowledge that sharing of their Account with other
          unauthorized persons, or allowing multiple User outside of their
          business to use their Account (“Multiple use”), may cause irreparable
          harm to Vizpro or Users themselves. Users shall completely indemnify
          Vizpro, our affiliates, directors, employees, agents and
          representatives against any loss or damages (including but not limited
          to loss of profits) suffered as a result of the Multiple use of their
          Account. Users also agree that in case of the Multiple use of their
          Account or User’s failure to maintain the security of their Account,
          Vizpro shall not be liable for any loss or damages arising from such a
          breach and shall have the right to suspend or terminate User’s Account
          without liability to the respective User.
        </p>
      </section>

      <section>
        <h2>3. Users' Responsibilities</h2>
        <p>All Users represent, warrant and agree that:</p>
        <ul>
          <li>
            they shall have complete power and authority to accept the Terms, to
            grant the license and authorization and to perform the obligations
            hereunder; and
          </li>
          <li>
            they use the Platforms and Services for business purposes only; and
          </li>
          <li>
            the address they provide when registering with Vizpro, must be the
            principal place of business of their business or their actual
            residential address.
          </li>
        </ul>
        <p>User represent, warrant and agree that:</p>
        <ul>
          <li>
            such information and material whether submitted during the
            registration process or thereafter throughout the continuation of
            the use of the Platforms or Services is true, accurate, current and
            complete, and
          </li>
          <li>
            they shall maintain and promptly amend all information and material
            to keep it true, accurate, current and complete.
          </li>
        </ul>
        <p>
          Upon becoming a User, they consent to the inclusion of the contact
          information about them in our User database and authorize Vizpro and
          our affiliates to share the contact information with other Users or
          otherwise use their personal information in accordance with the
          Privacy Policy.
        </p>
        <p>All Users represent, warrant and agree that:</p>
        <ul>
          <li>
            they shall be solely responsible for obtaining all necessary
            third-party licenses and permissions regarding any user content
            (“User Content”) that they submit;
          </li>
          <li>
            any User Content that they submit does not infringe or violate any
            of the copyright, patent, trademark, trade name, trade secrets or
            any other personal or proprietary rights of any third party (“Third
            Party Rights”); and
          </li>
          <li>
            they and their affiliates are not the subject of any trade
            restrictions, sanctions or other legal restrictions enacted by any
            country, international organization or jurisdiction.
          </li>
        </ul>
        <p>
          All Users further represent, warrant, and agree that the User content
          that they submit, post or display shall:
        </p>
        <ul>
          <li>be true, accurate, complete, and lawful;</li>
          <li>not be false, misleading, or deceptive;</li>
          <li>
            not contain information that is defamatory, libelous, threatening,
            or harassing; obscene, objectionable, offensive, sexually explicit,
            or harmful to minors;
          </li>
          <li>
            not contain information that is discriminatory or promotes
            discrimination based on race, sex, religion, nationality,
            disability, sexual orientation, or age;
          </li>
          <li>
            not violate the Services on the Platform, other terms, or any
            applicable additional agreements;
          </li>
          <li>
            not violate any applicable laws and regulations or promote any
            activities which may violate any applicable laws and regulations;
          </li>
          <li>
            not contain any link directly or indirectly to any other websites
            which include any content that may violate the Terms.
          </li>
        </ul>
        <p>All Users further represent, warrant and agree that they shall:</p>
        <ul>
          <li>
            carry on their activities on the Platforms in compliance with any
            applicable laws and regulations;
          </li>
          <li>
            carry on their activities in accordance with the Terms and any
            applicable additional agreements;
          </li>
          <li>
            not use the Services or Platforms to defraud any person or entity;
          </li>
          <li>
            not impersonate any person or entity, misrepresent themselves, or
            their affiliation with any person or entity;
          </li>
          <li>not engage in spamming or phishing;</li>
          <li>
            not engage in any other unlawful activities (including without
            limitation those which would constitute a criminal offense, give
            rise to civil liability, etc.) or encourage or abet any unlawful
            activities;
          </li>
          <li>
            not involve in any attempts to copy, reproduce, exploit, or
            expropriate Vizpro’s various proprietary directories, databases, and
            listings;
          </li>
          <li>
            not involve any computer viruses or other destructive or
            interruptive devices and codes that have the effect of damaging,
            interfering with, intercepting, or expropriating any software or
            hardware system, data, or personal information;
          </li>
          <li>
            not involve in any scheme to undermine the integrity of the data,
            systems, or networks used by Vizpro and/or any User of the Platforms
            or gain unauthorized access to such data, systems, or networks;
          </li>
          <li>
            not, and their director(s), officer(s), controlling party/ies,
            affiliates and legal jurisdiction in which any of the foregoing
            persons or entities are organized or have operations, be persons or
            entities that are subject to any economic or fraud sanctions of any
            governmental, international, or regulatory entities/authorities; and
          </li>
          <li>
            not engage in any activities that would otherwise create any
            liability for Vizpro or our affiliates.
          </li>
        </ul>
        <p>
          Users may not use the Services and User ID to engage themselves in
          activities which are identical or similar to Vizpro’s business.
        </p>
        <p>
          Users agree to provide all necessary information, materials and
          approval, and render all reasonable assistance and cooperation
          necessary for Vizpro’s provision of the Services, evaluating whether
          the User has breached the Terms and/or handled any complaint against
          other Users. User’s failure to do so may result in delay in, or
          suspension or termination of, the provision of any Services, Vizpro
          shall not be obliged to extend the relevant Service period nor shall
          be liable for any loss or damages arising from such delay, suspension,
          or termination.
        </p>
        <p>
          Users acknowledge and agree that Vizpro shall not be required to
          actively monitor nor exercise any editorial control whatsoever over
          the content of any message or material or information created,
          obtained or accessed through the Services or Platforms.
        </p>
        <p>
          Users acknowledge and agree that each User is solely responsible for
          observing applicable laws and regulations in its respective
          jurisdictions to ensure that all use of the Platforms and Services are
          in compliance with the same.
        </p>
      </section>

      <section>
        <h2>4. Permission to Use the Platform</h2>
        <p>
          We grant you a limited permission to access and make personal use of
          this Platform, but not to download (excluding page caches) or modify
          the Platform or any portion of it in any manner. This permission is
          limited only to the mobile application, as the User shall not do or
          attempt to post, make use of, enter data or access the website of
          Vizpro. This permission also does not include any resale or commercial
          use of this Platform or its contents; any collection and use of any
          service listings, descriptions, or any derivative use of this Platform
          or its contents, any downloading or copying of account information for
          the benefit of another User; or any use of data mining, robots, or
          similar data gathering and extraction tools.
        </p>
        <p>
          This Platform or any portion of it (including but not limited to any
          copyrighted material, trademarks, or other proprietary information)
          may not be reproduced, duplicated, copied, sold, resold, visited,
          distributed or otherwise exploited for any commercial purpose without
          express written consent by us as may be applicable.
        </p>
        <p>
          You may not frame or use framing techniques to enclose any trademark,
          logo, or other proprietary information (including images, text, page
          layout, or form) without our express written consent. You may not use
          any meta tags or any other text utilizing our name or trademark
          without our express written consent, as applicable. Any unauthorized
          use terminates the permission granted by us to you for access to the
          Platform with no prior notice. You may not use our logo or other
          proprietary graphic or trademark as part of an external link for
          commercial, personal or other purposes without our express written
          consent, as may be applicable.
        </p>
        <p>
          You agree and undertake not to perform restricted activities listed
          within this section; undertaking these activities will result in an
          immediate cancellation of User Account, Services, or any existing
          incomplete business with us and in severe cases may also result in
          legal action on:
        </p>
        <ul>
          <li>
            refusal to comply with the Terms described herein or any other
            guidelines and policies related to the use of the Platform as
            available on the Platform at all times;
          </li>
          <li>
            impersonate any person or entity or falsely state or otherwise
            misrepresent your affiliation with any person or entity;
          </li>
          <li>use the Platform for illegal purposes;</li>
          <li>
            attempt to gain unauthorized access to or otherwise interfere with
            or disrupt other computer systems or networks connected to the
            Platform or Services;
          </li>
          <li>
            interfere with other Users’ utilization and operation of the
            Platform;
          </li>
          <li>
            post, promote, or transmit through the Platform any prohibited
            materials as deemed illegal by the Islamic Republic of Pakistan;
            and/or
          </li>
          <li>
            use or upload, in any way, any software or material that contains,
            or which you have reason to suspect contains, viruses, damaging
            components, malicious code, or harmful components which may impair
            or corrupt the Platform’s data or damage or interfere with the
            operation of another User’s computer or mobile device or the
            Platform, and use the Platform other than in conformance with the
            acceptable use policies of any connected computer networks, any
            applicable internet standards, and any other applicable laws.
          </li>
        </ul>
        <p>
          You agree not to undertake any action to undermine the integrity of
          the computer systems or networks of Vizpro and/or any other User nor
          to gain unauthorized access to such computer systems or networks.
        </p>
        <p>
          By submitting any information on the Platforms or providing any User
          Content to Vizpro or our representative(s), and to the extent
          permitted under applicable laws, you grant an irrevocable, perpetual,
          worldwide, royalty-free, and sub-licensable (through multiple tiers)
          license to Vizpro to display, transmit, distribute, reproduce,
          publish, duplicate, adapt, modify, translate, create derivative works,
          and otherwise use any or all of the User Content in any form, media,
          or technology now known or not currently known in any manner and for
          any purpose which may be beneficial to the operation of the Platforms,
          the provision of any Services and/or the business of the User,
          provided that such User Content shall be anonymized first by Vizpro so
          as to ensure data protection and integrity of the User. You confirm
          and warrant to Vizpro that you have all the rights, power and
          authority necessary to grant the above license. Information that is
          protected under data protection laws will only be used and kept in
          compliance with those laws.
        </p>
      </section>

      <section>
        <h2>5. Conduct of Users</h2>
        <p>
          You must not use the Platform in any way that causes, or is likely to
          cause, the Platform or access to it to be interrupted, damaged or
          impaired in any way. You must not engage in activities that could harm
          or potentially harm the Platform, its employees, officers,
          representatives, stakeholders or any other party directly or
          indirectly associated with the Platform or access to it to be
          interrupted, damaged or impaired in any way. You understand that you,
          and not us, are responsible for all electronic communications and
          content sent from any of your devices to us and you must use the
          Platform for lawful purposes only. You are strictly prohibited from
          using the Platform:
        </p>
        <ul>
          <li>
            for fraudulent purposes, or in connection with a criminal offense or
            other unlawful activity.
          </li>
          <li>
            to send, use or reuse any material that does not belong to you; or
            is illegal, offensive (including but not limited to material that is
            sexually explicit content or which promotes racism, bigotry, hatred
            or physical harm), deceptive, misleading, abusive, indecent,
            harassing, blasphemous, defamatory, libelous, obscene, pornographic,
            pedophilic or menacing; ethnically objectionable, disparaging or in
            breach of copyright, trademark, confidentiality, privacy or any
            other proprietary information or right; or is otherwise injurious to
            third parties; or relates to or promotes money laundering or
            gambling; or is harmful to minors in any way; or impersonates
            another person; or threatens the unity, integrity, security or
            sovereignty of Pakistan or friendly relations with foreign states;
            or objectionable or otherwise unlawful in any manner whatsoever; or
            which consists of or contains software viruses, political
            campaigning, commercial solicitation, chain letters, mass mailings
            or any “spam”.
          </li>
          <li>to cause annoyance, inconvenience or needless anxiety.</li>
          <li>
            to any other purposes that is other than what is intended by us.
          </li>
        </ul>
      </section>

      <section>
        <h2>6. Submissions by Users</h2>
        <p>
          Anything that you submit to the Platform and/or provide to us,
          including but not limited to, questions, reviews, comments, and
          suggestions (collectively, “submissions”) will become our sole and
          exclusive property and shall not be returned to you. In addition to
          the rights applicable to any submission, when you post comments or
          reviews to the Platform, you also grant us the right to use the name
          that you submit, in connection with such review, comment, or other
          content. You shall not use a false e-mail address, pretend to be
          someone other than yourself or otherwise mislead us or third parties
          as to the origin of any submissions. We may, but shall not be
          obligated to, remove or edit any submissions without any notice or
          legal course applicable to us in this regard.
        </p>
      </section>

      <section>
        <h2>7. Breaches by Users</h2>
        <p>
          Vizpro reserves the right in their sole discretion to remove, modify
          or reject any User Content that Users submit to the Platforms which
          they reasonably believe is unlawful, violates the Terms, or could
          subject Vizpro or their affiliates to a certain liability, and is
          otherwise found inappropriate in Vizpro’s reasonable opinion.
        </p>
        <p>
          If any User breaches any Terms, or if Vizpro has reasonable grounds to
          believe that a User is in breach of any Terms, Vizpro shall have the
          exclusive right to take such disciplinary actions as they deem
          appropriate, including without limitation:
        </p>
        <ul>
          <li>
            suspending or terminating the User’s Account and any or all accounts
            determined to be related to such Account by Vizpro in their
            discretion;
          </li>
          <li>
            restricting, downgrading, suspending or terminating the subscription
            of, access to, or current or future use of any of the Service;
          </li>
          <li>
            removing any User Content that the User has submitted or imposing
            restrictions on the limits of User Content that the User may submit;
          </li>
          <li>
            imposing other restrictions on the User’s use of any features or
            functions of any service as Vizpro may consider appropriate in their
            sole discretion;
          </li>
          <li>
            any other corrective actions, discipline or penalties as Vizpro may
            deem necessary or appropriate in their sole discretion.
          </li>
        </ul>
        <p>
          Without limiting the generality of the provisions of the Terms, a User
          would be considered as being in breach of the Terms in any of the
          following circumstances:
        </p>
        <ul>
          <li>upon complaint or claim from any third party;</li>
          <li>
            vizpro has reasonable grounds to suspect that such User has used a
            stolen credit/debit card or other false or misleading information in
            any transaction with a counter party;
          </li>
          <li>
            vizpro has reasonable grounds to suspect that any information
            provided by the User is not current or complete or is untrue,
            inaccurate, or misleading; or
          </li>
          <li>
            vizpro believes that the User’s actions may cause financial loss or
            legal liability to Vizpro or their affiliates or any of the other
            Users.
          </li>
        </ul>
        <p>
          Vizpro reserves the right to cooperate fully with governmental
          authorities, private investigators and/or injured third parties in the
          investigation of any suspected criminal or civil wrongdoing. Further,
          to the extent permitted by applicable laws and policies, Vizpro may
          disclose the User’s identity, contact information and/or information
          regarding the User’s Account(s), transactions or activities carried
          out on or via the Platforms, if requested by a government or law
          enforcement body, an injured third party, or as a result of a
          subpoena, notice or other legal action. Vizpro shall not be liable for
          damages or results arising from such disclosure, and Users agree not
          to bring any action or claim against Vizpro for such disclosure.
        </p>
        <p>
          Vizpro may, at any time and in their reasonable discretion, impose
          limitations, suspend or terminate the User’s use of any Services or
          the Platforms without being liable to the Users if Vizpro has received
          notice that the User is in breach of any agreement or undertaking with
          any affiliate of Vizpro such breach involves or is reasonably
          suspected of involving dishonest or fraudulent activities. Vizpro
          shall not be required to investigate such breach or request
          confirmation from the User.
        </p>
        <p>
          Each User agrees to indemnify Vizpro, our affiliates, directors,
          employees, agents and representatives and to hold them harmless, from
          any and all damages, losses, claims and liabilities (including legal
          costs on a full indemnity basis) which may arise from your submission
          of any User Content, from your use of the Platforms or Services, or
          from your breach of the Terms.
        </p>
        <p>
          Each User further agrees that Vizpro is not responsible, and shall
          have no liability to you or anyone else for any User Content or other
          material transmitted over the Platforms, including fraudulent, untrue,
          misleading, inaccurate, defamatory, offensive or illicit material and
          that the risk of damage from such material rests entirely with each
          User. Vizpro reserves the right, at the expense of the Users, to
          assume the exclusive defense and control of any matter otherwise
          subject to indemnification by the Users, in such event the Users shall
          cooperate with Vizpro in asserting any available defenses.
        </p>
      </section>

      <section>
        <h2 style={{ textDecoration: "underline" }}>
          B. DISCLAIMERS AND LIABILITIES
        </h2>

        <h3>1. Continued Availability of the Platform</h3>
        <p>
          Please review our <a href="#">Privacy Policy</a>, which also governs
          User’s visit to the Platform. The personal information / data provided
          to us by you or your use of our Platforms will be treated as strictly
          confidential, in accordance with the privacy agreement and applicable
          laws and regulations. If you object to your information being
          transferred or used in the manner specified in the privacy agreement,
          please Do Not use the Platform.
        </p>
      </section>

      <section>
        <h2>2. Claims Against Objectionable Content</h2>
        <p>
          We list scores of services for rendering or acquiring by numerous
          Users on the Platform and host multiple comments on listings, it is
          not possible for us to be aware of the contents of each service listed
          for rendering or acquiring, or each comment or review that is
          displayed. Accordingly, we operate on a “claim, review and takedown"
          basis. If you believe that any content on the Platform is illegal,
          offensive (including but not limited to material that is sexually
          explicit content or which promotes racism, bigotry, hatred or physical
          harm), deceptive, misleading, abusive, indecent, harassing,
          blasphemous, defamatory, libelous, obscene, pornographic, pedophilic
          or menacing; ethnically objectionable, disparaging; or is otherwise
          injurious to third parties; or relates to or promotes money laundering
          or gambling; or is harmful to minors in any way; or impersonates
          another person; or threatens the unity, integrity, security or
          sovereignty of Pakistan or friendly relations with foreign states; or
          objectionable or otherwise unlawful in any manner whatsoever; or which
          consists of or contains software viruses, (“Objectionable Content”),
          please notify us immediately by following by writing to us on
          info@vizpro.com.pk we will make all practical endeavors to investigate
          and remove valid Objectionable Content complained about within a
          reasonable amount of time.
        </p>
        <p>
          which consists of or contains software viruses, (“Objectionable
          Content”), please notify us immediately by following by writing to us
          on info@vizpro.com.pk we will make all practical endeavors to
          investigate and remove valid Objectionable Content complained about
          within a reasonable amount of time. Please ensure to provide your
          name, email address, contact information and as many relevant details
          of the claim including name of Objectionable Content party, instances
          of objection, proof of objection amongst other. Please note that
          providing incomplete details will render your claim invalid and
          unusable for legal purposes.
        </p>
      </section>

      <section>
        <h2>3. Claims Against Infringing Content</h2>
        <p>
          We respect the intellectual property of others. If you believe that
          your intellectual property rights have been used in a way that gives
          rise to concerns of infringement, please write to us at
          info@vizpro.com.pk and we will make all reasonable efforts to address
          your concern within a reasonable amount of time. Please ensure to
          provide your name, address, contact information and as many relevant
          details of the claim including name of infringing party, instances of
          infringement, proof of infringement amongst other. Please note that
          providing incomplete details will render your claim invalid and
          unusable for legal purposes. In addition, providing false or
          misleading information may be considered a legal offense and may be
          followed by legal proceedings.
        </p>
        <p>
          While we cannot provide legal advice, nor share private information as
          protected by the law, we recommend that any questions or concerns
          regarding your rights may be routed to a legal specialist.
        </p>
      </section>

      <section>
        <h2>4. Disclaimer of Liability</h2>
        <p>
          While we have taken precautions to avoid inaccuracies in content of
          this Platform, all content, information, software, Services and
          related graphics are provided as is, without warranty of any kind. We
          do not implicitly or explicitly support or endorse the rendering or
          acquiring of any services on the Platform. At no time shall any right,
          title or interest in the services offered through or displayed on the
          Platform vest with us nor shall Vizpro have any obligations or
          liabilities in respect of any transactions on the Platform.
        </p>
        <p>
          We will not be responsible for any business or personal losses
          (including but not limited to loss of profits, revenue, contracts,
          anticipated savings, data, goodwill, or wasted expenditure) or any
          other indirect or consequential loss that is not reasonably
          foreseeable to both you and us when you commenced using the Platform.
        </p>
        <p>
          Any material downloaded or otherwise obtained through the Platforms is
          done at each User’s sole discretion and risk and each User is solely
          responsible for any damage to Vizpro computer system or loss of data
          that may result from the download of any such material. No advice or
          information, whether oral or written, obtained by any User from Vizpro
          or through or from the Platforms shall create any warranty not
          expressly stated herein.
        </p>
      </section>

      <section>
        <h2>5. Limitation of Liability</h2>
        <p>
          You agree that neither Vizpro, nor its employees, directors and
          personnel shall be liable for any direct, indirect, incidental,
          special, consequential or exemplary damages arising out of or in
          connection with (i) your use of the Platform, and (ii) in connection
          with the Services availed through the Platform. You further agree that
          Vizpro shall not be liable for any damages arising from interruption,
          suspension or termination of Services, including without limitation
          any direct, indirect, incidental, special, consequential or exemplary
          damages, whether such interruption, suspension or termination was
          justified or not, negligent or intentional, inadvertent or advertent.
        </p>
      </section>

      <section>
        <h2>6. Indemnity</h2>
        <p>
          You agree to defend, indemnify and hold harmless Vizpro and its
          officers, directors, employees, agents and affiliates (each, an
          “Indemnified Party”), from and against any losses, claims, actions,
          costs, damages, penalties, fines and expenses, including without
          limitation attorneys’ fees and expenses, that may be incurred by an
          Indemnified Party arising out of, relating to or resulting from your
          unauthorized use of the Platform or from any breach by you of these
          Terms, including without limitation any actual or alleged violation of
          any federal, provincial or local statute, ordinance, administrative
          order, rule or regulation. Vizpro shall provide notice to you promptly
          of any such claim, suit or proceeding and shall have the right to
          control the defense of such action, at your expense, in defending any
          such claim, suit or proceeding. You agree that this clause shall
          survive termination of these Terms.
        </p>
      </section>

      <section>
        <h2 style={{ textDecoration: "underline" }}>
          C. TRADEMARKS AND COPYRIGHTS
        </h2>
        <p>
          <b>Vizpro.com.pk, Vizpro logo, Vizpro, Vizlink</b> and other marks
          indicated on our Platform are trademarks or registered trademarks in
          the relevant jurisdiction(s). Our graphics, logos, page headers,
          button icons, scripts and Service names are the trademarks or trade
          dress and may not be used in connection with any service that does not
          belong to us or in any manner that is likely to cause confusion among
          Users, or in any manner that disparages or discredits us. All other
          trademarks that appear on this Platform are the property of their
          respective owners, who may or may not be affiliated with, connected
          to, or sponsored by us.
        </p>
        <p>
          All intellectual property rights, whether registered or unregistered,
          in the Platform, information content on the Platform and all the
          website design, including, but not limited to text, graphics,
          software, photos, video, music, sound, and their selection and
          arrangement, and all software compilations, underlying source code and
          software shall remain our property. The entire contents of the
          Platform also are protected by copyright as a collective work under
          Pakistani copyright laws and international conventions. All rights are
          reserved.
        </p>
        <p>
          Our software includes any software (including any updates or upgrades
          to the software and any related documentation) that we make available
          to you from time to time for your use in connection with the Platform
          (“Software”).
        </p>
        <p>
          You may use the Software solely for purposes of enabling you to use
          and enjoy our Services as permitted by these Terms and any related
          applicable terms as available on the Platform. You may not incorporate
          any portion of the Software into your own programs or compile any
          portion of it in combination with your own programs, transfer it for
          use with another service, or sell, rent, lease, lend, loan, distribute
          or sub-license the Software or otherwise assign any rights to the
          Software in whole or in part. You may not use the Software for any
          illegal purpose. We may cease providing you Services and we may
          terminate your right to use the Software at any time. Your rights to
          use the software will automatically be terminated without notice from
          us if you fail to comply with any of the Terms listed herein or across
          the Platform. Additional third-party terms contained within the
          Platform or distributed as such that are specifically identified in
          related documentation may apply and will govern the use of such
          Software in the event of a conflict with these Terms. All Software
          used in any of our Services is our property and/or our affiliates or
          its Software suppliers and protected by the laws of Pakistan including
          but not limited to any other applicable copyright laws.
        </p>
        <p>
          You may not, and will not encourage, assist or authorize any other
          person to copy, modify, reverse engineer, decompile or disassemble, or
          otherwise tamper with our Software whether in whole or in part, or
          create any derivative works from or of the Software.
        </p>
      </section>

      <section>
        <h2 style={{ textDecoration: "underline" }}>D. GENERAL PROVISIONS </h2>
        <h3>1. Communicating with Us</h3>
        <p>
          When you visit the Platform, or send e-mails to us, you are
          communicating with us electronically. You will be required to provide
          a valid phone number while placing an order with us. We may
          communicate with you by e-mail, short messaging service, and phone
          call or by posting notices on the Platform or by any other mode of
          communication we choose to employ. For contractual purposes, you
          consent to receive communications (including transactional,
          promotional and/or commercial messages), from us with respect to your
          use of the Platform (and/or placement of your order) and agree to
          treat all modes of communication with the same importance.
        </p>
        <h3>2. Amendments to Conditions or Alterations of Service</h3>
        <p>
          We reserve the right to make changes to the Platform, its policies,
          these Terms and any other publicly displayed condition or Service
          promised at any time. You will be subject to the policies and Terms in
          force at the time you used the Platform unless any change to those
          policies or these Terms is required to be made by law or government
          authority (in which case it will apply to orders previously placed by
          you).
        </p>
        <p>
          Vizpro reserves the right, at its sole and absolute discretion, to
          change, modify, add to, supplement or delete any of the terms and
          conditions of these Terms, effective immediately without prior notice.
          Your continued use of the Platform following any revision to these
          Terms shall constitute your complete and irrevocable acceptance of any
          and all such changes. Contact us if you have any comments or
          questions, please do not hesitate to reach out to us at
          info@vizpro.com.pk
        </p>
        <h3>3. Events Beyond Our Control</h3>
        <p>
          We will not be held responsible for any delay or failure to comply
          with our obligations under these conditions if the delay or failure
          arises from any cause or reason which is beyond our reasonable
          control.
        </p>
        <p>
          Under no circumstances shall Vizpro be held liable for any delay or
          failure or disruption of the Services delivered through the Platforms
          resulting directly or indirectly from acts of nature, forces or causes
          beyond our reasonable control, including without limitation, internet
          failures, computer, telecommunications or any other equipment
          failures, electrical power failures, strikes, labor disputes, riots,
          insurrections, civil disturbances, shortages of labor or materials,
          fires, flood, storms, explosions, acts of god, war, governmental
          actions, orders of domestic or foreign courts or tribunals or
          non-performance of third parties.
        </p>
        <h3>4. Waiver</h3>
        <p>
          You acknowledge and recognize that we are a private commercial
          enterprise and reserve the right to conduct business to achieve our
          objectives in a manner we deem fit. You also acknowledge that if you
          breach the Terms stated on our Platform and we take no action, we are
          still entitled to use our rights and remedies in any other situation
          where you breach these Terms.
        </p>
        <h3>5. Termination</h3>
        <p>
          In addition to any other legal or equitable remedies, we may, without
          prior notice to you, immediately terminate these Terms or revoke any
          or all of your rights granted under these Terms. Upon any termination
          of this agreement, you shall immediately cease all access to and use
          of the Platform and we shall, in addition to any other legal or
          equitable remedies, immediately revoke all password(s) and account
          identification issued to you and deny your access to and use of this
          Platform in whole or in part. Any termination of this Agreement shall
          not affect the respective rights and obligations (including without
          limitation, payment obligations) of the parties arising before the
          date of termination. You furthermore agree that the Platform shall not
          be liable to you or to any other person as a result of any such
          suspension or termination. If you are dissatisfied with the Platform
          or with any terms, conditions, rules, policies, guidelines, or
          practices in operating the Platform, your sole and exclusive remedy is
          to discontinue using the Platform.
        </p>
        <h3>6. Governing Law and Jurisdiction</h3>
        <p>
          These Terms are governed by the laws of Pakistan. The Pakistani courts
          in Lahore shall have the exclusive jurisdiction and venue over any
          dispute arising out of or relating to these Terms, and each party
          hereby consents to the jurisdiction and venue of such courts. If any
          provision of these Terms is found to be invalid in any court having
          competent jurisdiction, the invalidity of such provision shall not
          affect the validity of the remaining provisions of this Terms of
          Service, which shall remain in full force and effect. Any offer for
          any feature, Service or application made on this application is void
          where prohibited.
        </p>
      </section>

      <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>

      <section>
        <p>
          Vizpro (Private) Limited (“Vizpro”, “Company”, “we”, “us” or “our”)
          operates the website located at{" "}
          <a href="http://www.vizpro.com.pk">www.vizpro.com.pk</a> and other
          related websites, domains, sub-domains and mobile applications with
          links to this policy operated by <b>Vizpro</b>, including but not
          limited to <b>Vizlink</b>, our flagship digital transformation
          platform for retailers and distributors (collectively, the
          “Platform”). We have developed this privacy policy (the “Privacy
          Policy”) to explain what, how and why we collect, use and disclose
          information from and/or about you when you use the Platform or our
          services. We are committed to protecting and respecting your privacy.
        </p>
        <p>
          The terms “you” and “your” refer to the user of the Platform and our
          services. The term “Services” and/or “Products” refers to any
          services/products offered by Vizpro whether on the Platform or
          otherwise. Please read this Privacy Policy before using the Platform
          or submitting any personal information to Vizpro.
        </p>
        <p>
          All visitors to the Platform are advised to read and understand this
          Privacy Policy carefully, as by accessing the Platform, you agree to
          be bound by the terms and conditions of the Privacy Policy and consent
          to the collection, storage and use of information relating to you as
          provided herein.
        </p>
        <p>
          BY USING THE PLATFORM, YOU AGREE THAT WE CAN COLLECT AND USE YOUR
          PERSONAL INFORMATION AS DESCRIBED IN THIS PRIVACY POLICY. BY USING THE
          PLATFORM, YOU AGREE TO THE CONTENTS OF THIS PRIVACY POLICY GIVE YOUR
          CONSENT TO US FOR COLLECTING YOUR PERSONAL INFORMATION.
        </p>
        <p>This Privacy Policy explains:</p>
        <ul>
          <li>what information we collect and why we collect it;</li>
          <li>how we use that information; and</li>
          <li>
            the choices we offer, including how to access and update
            information.
          </li>
        </ul>
        <p>
          We have tried to keep the Privacy Policy as simple as possible, but if
          you are not familiar with terms like cookies, IP addresses, pixel tags
          and browsers, then read about these key terms first. Your privacy
          matters to us so please do take the time to get to know our practices
          and if you have any questions feel free to contact us by sending an
          email to <b>info@vizpro.com.pk</b>.
        </p>
        <h3>CHANGES TO PRIVACY POLICY</h3>
        <p>
          We may update/change this Privacy Policy from time to time in response
          to changing legal, technical or business developments. Any changes we
          may make to this Privacy Policy in the future will be posted on the
          Platform and, where appropriate, notified to you when you next
          start/open/log in the Platform. Once posted on the Platform, the
          new/amended Privacy Policy will be effective immediately. The
          new/amended terms may be displayed on-screen and you may be required
          to read and accept them to continue your use of the Platform or the
          Services, including any additional terms of use apply to your use of
          any other linked website(s)/app(s).
        </p>
        <p>
          This Privacy Policy sets out the basis on which any personal data we
          collect from you with your consent, or that you provide to us, will be
          processed by us. Please read the following carefully to understand our
          views and practices regarding your personal data and how we will treat
          it. Please also note that the personal data that may be collected by
          Vizpro will only be used for the purpose of determining whether you
          are eligible or not for Vizpro Services and the terms and conditions
          of such Services.
        </p>
        <h3>LEGAL RULES WE FOLLOW</h3>
        <p>
          Vizpro, a non-licensed regulated entity, works and operates together
          with licensed partners such as NBFCs, banks and other financial
          institutions as regulated by SECP/SBP under specific legal laws, rules
          and regulations including, but not limited to:
        </p>
        <ul>
          <li>
            <a href="https://na.gov.pk/uploads/documents/1329727963_180.pdf">
              Pakistan Telecommunication (Re-Organisation) Act, 1996
            </a>
          </li>
          <li>
            <a href="https://na.gov.pk/uploads/documents/1470910659_707.pdf">
              Prevention of Electronic Crimes Act, 2016
            </a>
          </li>
          <li>
            <a href="https://pakistancode.gov.pk/english/UY2FqaJw1-apaUY2Fqa-apaUY2FqbZw%3D-sg-jjjjjjjjjjjjj">
              Investigation for Fair Trial Act, 2013
            </a>
          </li>
          <li>
            <a href="https://moitt.gov.pk/SiteImage/Misc/files/Telecom-Consumer-protection-2016Regulation-adm.pdf">
              Telecommunication Consumer Protection Regulations, 2016
            </a>
          </li>
          <li>
            <a href="https://www.pta.gov.pk/media/pro_spam_reg_09.pdf">
              Protection from SPAM, Unsolicited fraudulent and obnoxious
              communication Regulations 2009
            </a>
          </li>
          <li>All the NBFC-IFS regulations are laid out by the SECP. </li>
          <li>
            All the banking, payment gateway, AML, and counter-terrorism
            regulations laid out by the SBP in the{" "}
            <a href="https://www.sbp.org.pk/bprd/2008/annex_c2.pdf">
              Branchless Banking Act of 2008.
            </a>
          </li>
          <li></li>
        </ul>
        <p>
          You, as a User, may be subject to the above mentioned laws, as
          necessary.
        </p>
        <h3>COLLECTION OF INFORMATION</h3>
        <p>
          In order to enhance the user experience and provide our Services, we
          collect, process and store personal information provided by you from
          time to time on the Platform., Company collects information about you:
          (a) information you affirmatively and voluntarily give to us; (b)
          information automatically collected when you visit the Platform or use
          any of our Services; and (c) information we receive from other valid
          sources such as third party information.
        </p>
        <h4>A) Information we may collect from you</h4>
        <p>This includes information submitted when you:</p>
        <ul>
          <li>
            Create, register or update your Vizpro account, which may include
            your name, age, CNIC number, email, phone number, username and
            password, address, payment or banking information, date of birth and
            profile picture.
          </li>
          <li>
            Create, register or update your account on such platforms that the
            Platform is imbedded in.
          </li>
          <li>Use and/or subscribe to our Services.</li>
          <li>Subscribe to our newsletters or promotions.</li>
          <li>
            When you report a problem with the Platform and/or our Services,
            while corresponding with us for customer support, including your
            name, address, e-mail address and phone number, the handheld or
            mobile device (the “Device”) phone number, SIM card, age, username,
            password, and other registration information, financial and credit
            information, personal description, and/or photograph.
          </li>
          <li>
            Contact us for information, questions or feedback about our Products
            and Services.
          </li>
          <li>
            Make an online payment, including your payment information,
            credit/debit card details, one-time passwords and other related
            information.
          </li>
          <li>Report problems for troubleshooting.</li>
        </ul>
        <h4>B) Information we collect about you and your Device</h4>
        <p>
          Regarding each time you visit the Platform, we may automatically
          collect and analyze the following information:{" "}
        </p>
        <ul>
          <li>
            When you communicate with us via our customer services department
            i.e. chat service, email, phone, through the Platform or otherwise,
            we may maintain a record a copy of your communication and your
            feedback/suggestions to us. We may ask for additional information to
            verify your identity;
          </li>
          <li>
            Where you have signed up for Services, we may collect information
            including but not limited to basic know-your-customer (KYC)
            information, name, CNIC number (including picture of front and back
            side of the card, a picture of your face along with CNIC, full name,
            CNIC number, issue date, expiry date, date of birth, city of birth,
            mother’s name), phone number, email address etc., current
            residential address, city, gender and marital status;
          </li>
          <li>
            Your employment, business or any additional information which is
            included in your loan KYC form.
          </li>
          <li>
            Your preferences for particular Products and Services, based on
            information provided by you or from your use of ours (or third
            party) network, products and services.
          </li>
          <li>
            <b>E-Wallets account and communication date</b>: details pertaining
            to your e-wallet account, including account number or username,
            account balance, transaction history and linked payment methods.
          </li>
          <li>
            <b>Unique application numbers</b>: When you install or uninstall a
            Service containing a unique application number or when such a
            Service searches for automatic updates, that number and information
            about your installation, for example, the type of operating system,
            may be sent to us;
          </li>
          <li>
            <b>Location information</b>: Depending on the Services that you use,
            and your app settings or Device permissions, we may collect your
            real time information, or approximate geo-location information as
            determined through data such as GPS, IP address;
          </li>
          <li>
            <b>Usage and Preference Information</b>: We collect information as
            to how you interact with our Services, preferences and settings
            chosen including the last time you used them, the duration of usage,
            the quantity of transactions made, the timing of such transaction
            and your activity or in-activity on the Platform;
          </li>
          <li>
            <b>Geo-location Data</b>: when you use our telecommunication
            Services, including call, SMS or broadband services, we may collect
            your geo-location data. If you opt for location-based services, such
            as directional applications on your Device or participate in
            location-based promotional activities, your geo-location data may be
            captured.{" "}
          </li>
          <li>
            <b>Device Information</b>: We may collect information from and about
            the devices you use to access our Platform and/or Services,
            including, IP address, the type of mobile device you use, mobile
            network information, mobile network information, your device
            operating system, operating systems and versions, software and
            hardware attributes, pages viewed, number of sessions, unique
            visitors, file names and versions, preferred languages, the type of
            browser you use and browsing patterns, your Device’s location and
            time zone setting (Device Information), traffic data, location data,
            weblogs and other communication data (Log Information) and/or
            details of how you have interacted with our Services and Platforms.
            In addition we gather statistical information about the Platform and
            visitors to the Platform including, browser software, operating
            system, software and hardware attributes, pages viewed, number of
            sessions and unique visitors. Collecting this information enables us
            to better understand the visitors who come to our Platform, where
            they come from, and what content is of interest to them. We use this
            information for our internal analytics purposes and to improve the
            quality and standard of our Platform. Some of this information may
            be collected using cookies and similar tracking technology;
          </li>
          <li>
            <b>Stored information and files</b>: Depending on your app settings
            or Device permissions, we may also access metadata and other
            information associated with other files stored on your Device. This
            may include, for example, photographs, personal contacts and address
            book information. If you permit the Platform to access the address
            book on your Device, we may collect names and contact information
            from your address book to facilitate social interactions through our
            Services and for other purposes described in this Privacy Policy or
            at the time of consent or collection;
          </li>
          <li>
            <b>Transaction Information</b>: We collect transaction details
            related to your use of our Services, including geo-location data
            associated with the transaction (e.g., shop and agent locations),
            payment gateway details (e.g., transaction IDs, digital wallet
            identifiers, and linked account information), financing details
            (e.g., loan amounts, repayment terms, and status), and order and
            delivery details (e.g., invoice uploads, order value, and stock
            status). Additionally, we gather information about your activity on
            the Services, including the full Uniform Resource Locators (URL),
            the type of Services/Products you requested or provided, comments,
            domain names, search results selected, number of clicks, information
            and pages viewed and searched for, the order of those pages, length
            of your visit to our Services, the date and time you used the
            Services, amount charged for every transaction made, details
            regarding application of promotional code, methods used to browse
            away from the page and any phone number used to call our customer
            service number, the amount of money in your account, timing of the
            transactions made, general details about recipient of the
            transactions being made from your account and other related
            transaction details.
          </li>
        </ul>
        <h4>C) Information we receive from other sources</h4>
        <ul>
          <li>
            We may receive information about you from third parties, such as
            mobile wallet operators, financial institutions, credit bureaus,
            duly licensed lenders, other users, partners (including ad partners,
            analytics providers, search information providers), or our
            affiliated companies or if you use any of the other websites/apps we
            operate or the other Services we provide.{" "}
          </li>
          <li>
            We may receive personal information about you from third parties
            that are engaged by us to assist with providing verification
            services and conducting suitable money laundering and KYC and AML
            (anti-money laundering) checks on users of the Platform. This may
            include your name, email address, company details and contact
            information.
          </li>
          <li>
            If you choose to participate in reviewing or rating the Services on
            the Platform, we may receive personal information about you from
            third parties that work with us to conduct reviews into our Services
            and/or rate us.
          </li>
          <li>
            Subject to your consent, we may collect your information and
            activity from payment providers, advertising networks, analytics
            providers, search information providers and social media platforms.{" "}
          </li>
          <li>
            We may collect social media information you use to log in and
            interact with our Platform, as long as you agree to share such
            information with us.{" "}
          </li>
        </ul>
        <h3>REMOVAL OF CONSENT FOR COLLECTING FURTHER INFORMATION</h3>
        <p>
          You may withdraw your consent for further collection of the above
          information at any time by logging out and uninstalling the Platform
          from your Device.
        </p>
        <h3>TRACKING AND COOKIES</h3>
        <p>
          Vizpro may use mobile tracking technologies and/or website cookies to
          distinguish you from other users of the Platform. This helps us to
          provide you with a good experience when you use the App or browse any
          of the sites and also allows us to improve the App and our sites.
        </p>
        <p>
          A “cookie” is a small piece of information stored on a web
          browser/device so it can be later read back. Cookies are useful for
          enabling the browser/device to remember information specific to a
          given user. We place both permanent and temporary cookies. The cookies
          do not contain any of your personally identifiable information.
        </p>
        <h4>USES MADE OF THE INFORMATION</h4>
        <p>
          Vizpro may associate any category of information with any other
          category of information and will treat the combined information as
          personal data in accordance with this Privacy Policy.
        </p>
        <p>Information collected by us shall be used for the purpose of:</p>
        <ul>
          <li>
            To allow you to use Services on the Platform, like:
            <ul>
              <li>Managing your account;</li>
              <li>Performing payments;</li>
              <li>Carrying out credit checks;</li>
              <li>Communicating with you.</li>
            </ul>
          </li>
          <li>
            To allow you to undertake or initiate any transactions on the
            Platform;
          </li>
          <li>
            For our internal record keeping, quality assurance, training, and
            feedback;
          </li>
          <li>To improve our Services;</li>
          <li>
            To improve your usage of the Platform, improve User experience,
            etc.;
          </li>
          <li>
            To process payments with respect to transactions initiated on the
            Platform;
          </li>
          <li>
            To communicate important notices or changes to the Services provided
            by the Company on the Platform, use of the Platform, and the
            terms/policies which govern the relationship between you and the
            Company;
          </li>
          <li>
            For internal purposes of the Company, such as auditing, data
            analysis, and research conducted either indirectly or directly by
            the Company. Personal, aggregated statistics, and de-identified
            information related to sales, Services, customers, network traffic,
            and location patterns are analyzed;
          </li>
          <li>
            Creating User profiles to offer you personalized content, products,
            and Services, ensuring that you receive recommendations aligned with
            your interests;
          </li>
          <li>For promotion and marketing purposes by the Company;</li>
          <li>For any other purposes with your consent; and/or</li>
          <li>
            For determining whether or not to provide a financial service or
            product to you, the amount of such exposure, and the terms and
            conditions applicable to such services or products.
          </li>
        </ul>
        <p>
          From time to time, we may use your information to customize, develop
          and improve the Platform and/or Services according to your interests.
        </p>
        <h3>DISCLOSURE OF YOUR INFORMATION</h3>
        <p>
          Vizpro does not disclose information about identifiable individuals to
          other parties, but we may provide them with anonymous, encrypted
          and/or anonymized aggregate information/data about our users. We will
          use your data for the purposes of compiling statistics relating to our
          user base or financial product or services and may disclose such
          information to any third party for such purposes, provided that such
          information will always be anonymous. Should we wish to use your
          information for marketing purposes, we will inform you prior to such
          use. You shall be entitled to prevent such usage by informing us,
          within ten (10) days of being informed of the proposed use, that you
          do not wish to disclose such information. You can also exercise the
          right at any time by contacting us at <b>info@vizpro.com.pk</b>
        </p>
        <p>
          Data collected from you from the Platform shall only be used for the
          uses mentioned above other than that, Vizpro may disclose some or all
          of the data to:
        </p>
        <ul>
          <li>
            <b>Regulated entities</b>: Connect to mobile wallet providers,
            credit bureaus, NADRA, banks, lenders, insurers, or other partner
            financial and non-financial institutions.
          </li>
          <li>
            <b>KYC & AML Verification</b>: Third parties engaged by us to assist
            with providing verification services and conducting suitable money
            laundering and KYC (Know Your Customer) and AML (Anti-Money
            Laundering) checks on users of the Platform.
          </li>
          <li>
            <b>Vizpro’s affiliate companies</b>: Any member of our group,
            including subsidiaries, our ultimate holding company, and its
            subsidiaries.
          </li>
          <li>
            <b>Law enforcement agencies</b>: Any local or international law
            enforcement, court of competent jurisdiction, competent regulatory,
            or governmental agencies to assist in the prevention, detection,
            investigation, or prosecution of criminal activities or fraud.
          </li>
          <li>
            <b>Financial technology providers</b>: We collaborate with financial
            technology providers who develop and offer various financial
            products; your information may be shared with them in this context.
          </li>
          <li>
            <b>Third parties</b> in the following cases:
            <ul>
              <li>
                With prospective business partners or in the event that we sell
                or buy any business or assets, in which case we may disclose
                your personal data to the prospective seller or buyer of such
                business or assets. If Vizpro or substantially all of its assets
                are acquired by a third party, personal data held by it about
                its customers will be one of the transferred assets.
              </li>
              <li>
                If you request integration with third-party services, such as
                social networks, we may share your information as needed to
                enable these integrations.
              </li>
              <li>
                You consent to such disclosure to the relevant third parties.
              </li>
            </ul>
          </li>
          <li>
            <b>Debit collection agencies and credit check agencies</b>: We may
            engage third-party service providers, such as debit collection
            agencies and credit check agencies, as necessary.
          </li>
          <li>
            <b>Advertising, measurement, and analytics partners</b>: Following
            your consent, we may collaborate with third parties for advertising,
            measurement, and analytics purposes.
          </li>
          <li>
            Comply with our duty to disclose or share your personal data in
            order to comply with any legal or regulatory obligation or request.
          </li>
          <li>
            Enforce our terms and conditions and other agreements or to
            investigate potential breaches.
          </li>
          <li>
            Publish statistics relating to the use of the Platform, in which
            case all information will be aggregated and made anonymous.
          </li>
          <li>
            Protect us from incurring any legal liability. In such an event, we
            shall be under no obligation to specifically inform you or seek your
            approval or consent.
          </li>
          <li>
            Protect the personal safety of you, the Company, its members and
            employees, or any person, in any emergency.
          </li>
          <li>
            Agencies, counsels, and/or any of our other agents to enforce
            Vizpro’s rights against you.
          </li>
          <li>
            Third-party service providers solely for the purpose of assisting or
            rendering services to us in the administration of our Services.
          </li>
          <li>
            The information collected from you may also be used by us to file a
            complaint against you and to initiate or commence proceedings
            against you for recovery of outstanding amounts.
          </li>
          <li>
            Third parties for the purpose of insuring Vizpro from users of the
            Platform in relation to default or other credit loss and
            safeguarding you from fraud or unauthorized charges.
          </li>
        </ul>
        <h3>WHERE VIZPRO STORES YOUR PERSONAL DATA AND ITS PROTECTION</h3>
        <p>
          All data and information is saved and stored on servers, which are
          secured with passwords and pins to ensure no unauthorized person(s)
          has access to it. Once your information is in our possession, we
          adhere to strict security guidelines, protecting it against
          unauthorized access. We shall take reasonable steps to help protect
          your rights of privacy and your information (personal or otherwise) in
          an effort to prevent loss, misuse, unauthorized access, disclosure,
          alteration, or destruction of such information, in compliance with the
          applicable laws. However, we cannot guarantee security of your stored
          data and information.
        </p>
        <p>
          The data that we collect from you may be transferred to, and stored
          at, any destination as per applicable regulations. By submitting your
          personal data, you agree to this transfer, storing or processing.
        </p>
        <p>
          We take all steps reasonably necessary to ensure that your data is
          treated securely and in accordance with this Privacy Policy. Where we
          have given you (or where you have chosen) a password that enables you
          to access certain parts of the Platform, you are responsible for
          keeping this password confidential. We ask you not to share your
          username and password with anyone.
        </p>
        <p>In addition to the above, we protect your information through:</p>
        <ul>
          <li>
            <b>Data encryption</b>: When you use our services and log into your
            account, we protect your data by turning it into secret code using
            strong security methods like TLS and SSL. We use this encryption on
            all our web pages where we collect personal info. To buy things on
            these pages, you need to use a secure browser like Internet
            Explorer, Safari, Firefox, or Chrome. This keeps your personal data
            private when it travels over the Internet.
          </li>
          <li>
            <b>Third-party protection</b>: When we get help from other companies
            to handle your personal info, we make sure they follow strict rules
            to protect it. They have limited access to the data and must obey
            the law. We also ensure our products and services are built with
            privacy and data protection in mind from the start.
          </li>
        </ul>
        <h3>RETENTION OF INFORMATION</h3>
        <p>
          We will exclusively handle your personal information for lawful
          purposes and solely for the duration required to fulfil those
          objectives. Once your personal information is no longer needed, we
          will securely and responsibly dispose of it, adhering to relevant data
          retention laws. As an illustration, the State Bank of Pakistan
          mandates the retention of customer records for a period of 10 years.
        </p>
        <h3>CONSENT AND AUTHORIZATION TO USE OF INFORMATION </h3>
        <p>
          By using our Platform, you agree and consent, without any reservation:{" "}
        </p>
        <p>
          (a) To allow us to access any and all information and data about you
          or contained in your mobile device, in the manner detailed in this
          Policy;{" "}
        </p>
        <p>
          (b) To allow us to use all such information and data in such manner as
          we may deem fit for our purposes, including sharing the data with one
          or more third parties inside Pakistan, without any commercial benefit
          of the same to you;{" "}
        </p>
        <p>
          (c) To allow us to store and utilize the data for such period of time
          as we deem fit for our purposes;
        </p>
        <p>
          (d) To allow us to use the data so collected for any purpose in
          pursuance to your use of the Platform.
        </p>
        <p>
          Your consent is of your own free will, without any duress or coercion
          of any nature. By using our Platform, you confirm unequivocally that
          you have read the Policy and are aware of and have no objection to the
          collection, storage and use of your data by Vizpro.
        </p>
        <h3>YOUR RIGHTS</h3>
        <p>
          We place great importance on ensuring your awareness of your privacy
          rights. To that end, we have outlined a non-exhaustive list of privacy
          rights that you can exercise while entrusting us with your
          information:
        </p>
        <ul>
          <li>
            <b>Right to revoke consent</b>: If you have granted consent for us
            to utilize, process, or share your personal data, you have the
            option to withdraw that consent at any time, unless the information
            is essential for us to carry out our services.
          </li>
          <li>
            <b>Right to access your information</b>: You have the ability to
            access and request a copy of the personal data we hold about you
            whenever you wish. You can do this by getting in touch with us or by
            accessing the information directly through your e-wallet account.
          </li>
          <li>
            <b>Right to deletion</b>: You can request that we delete specific
            portions of the personal data we have on you, provided certain
            conditions are met:
            <ul>
              <li>
                The information is no longer necessary for our purposes, and
                there is no legal requirement for us to retain it.
              </li>
              <li>
                Other legal justifications that permit you to make such a
                request.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          While we will make every effort to accommodate your request, please
          keep in mind that this may render you ineligible for certain Services.
        </p>
      </section>
    </div>
  );
}
